<div class="row">
  <div class="col-md-12">
     <div class="card">
        <div class="row">
           <div class="col-md-12">
              <h1 class="headingValue">Permission For Temporary Registration(PTR) Application Form</h1>
           </div>
        </div>
        <form id="guruId" [formGroup]="formGroupId" enctype="multipart/form-data" role="form" autocomplete="off" class="has-validation-callback">
           <div class="bt-tab-content-main">
              <div class="tab-content" style="margin-top: 15px">
                 <div id="signin">
                    <div class="col-md-12">
                       <h5 class="headingValue">Applicant Details</h5>
                       <hr>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="phoneNo" class="required">Institution Type <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="institutionTypeName" formControlName="institutionTypeName" class="form-control" readonly>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="grivFirstName" class="required">Applicant Name <span class="text-danger">*</span>
                                </label>
                                <input id="name" name="name" tabindex="1" formControlName="name" placeholder="Name of College/ Organisation/Association/ Trust/Hospital/University" type="text" class="form-control" readonly>
                             </div>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="grivFirstName" class="required">Email Address <span class="text-danger">*</span>
                                </label>
                                <input id="email" name="email" tabindex="2" formControlName="userEmail" maxlength="100" placeholder="Email Address" type="text" class="form-control" value="" readonly>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="phoneNo" class="required">Mobile Number <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="mobileNo" readonly formControlName="mobileNumber" placeholder="Mobile Number">
                             </div>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6" *ngIf="userDetails?.landlineNumber !== null && userDetails?.landlineNumber !== ''">
                             <div class="form-group">
                                <label for="landlineNumber" class="required">Landline Number <span class="text-danger"></span>
                                </label>
                                <input type="text" class="form-control" id="landlineNumber" readonly formControlName="landlineNumber" placeholder="Landline Number">
                             </div>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6" *ngIf="showRegistrationDetails">
                             <div class="form-group">
                                <label for="phoneNo" class="required">Registration Number <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="certificateRegistration" formControlName="certificateRegistration" placeholder="Registration Number" maxlength="15" [ngClass]="{ 'is-invalid': f.certificateRegistration.invalid && (f.certificateRegistration.dirty || f.certificateRegistration.touched) }" data-validation-error-msg='Registration number is required'>
                                <div *ngIf="submitted && formGroupId.controls['certificateRegistration'].hasError('required')" class="failed-validation" class="errorColor"> Registration Number is Required </div>
                                <div *ngIf="formGroupId.controls['certificateRegistration'].hasError('maxlength')" class="failed-validation" class="errorColor">
                                   <b> Registration Number cannot be more than 10 characters long. </b>
                                </div>
                                <div *ngIf="formGroupId.controls['certificateRegistration'].hasError('minlength')" class="failed-validation" class="errorColor">
                                   <b> Registration Number cannot be less than 6 characters long. </b>
                                </div>
                             </div>
                          </div>
                       </div>
                       <!--UPLOAD REGISTRATION BY SUGAND-->
                       <div class="row">
                          <div class="col-md-6" *ngIf="showRegistrationDetails">
                             <div class="form-group">
                                <label for="phoneNo" class="required">Upload Registration Ceritificate <span class="text-danger">*</span>
                                </label>
                                <span> (Max size.200 KB, file format .pdf only) </span>
                                <br>
                                <input type="file" accept="pdf" #documentaryProof class="form-group" (change)="onSelectFile($event,'documentaryProof')">
                                <br>
                                 <div class="iconCard" *ngIf="formGroupId.value.documentaryProof?.includes('/')">
                                    <span><i class="far fa-file-alt docIcons"></i> {{formGroupId.value.documentaryProof?.split('/').pop()}}</span>
                                    <a class="downloadView" (click)="viewDocuments(formGroupId.value.documentaryProof, formGroupId.value.documentaryProof?.split('/').pop())">
                                       <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
                                    </a> 
                                 </div>
                                <div *ngIf="submitted && formGroupId.controls['documentaryProof'].hasError('required')" class="failed-validation" class="errorColor"> Registration Certificate is Required </div>
                             </div>
                          </div>
                       </div>
                    </div>
                    <div class="col-md-12">
                       <h5 class="headingValue">Address Information</h5>
                       <hr>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label class="required">Address Line 1 <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" placeholder="Address Line 1" formControlName="addressLine1" readonly>
                             </div>
                          </div>
                          <div class="col-md-6" *ngIf="userDetails?.addressLine2!=null && userDetails?.addressLine2!=''">
                             <div class="form-group">
                                <label class="required">Address Line 2 <span class="text-danger"></span>
                                </label>
                                <input type="text" class="form-control" placeholder="Address Line 2" formControlName="addressLine2" readonly>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group" tabindex="1">
                                <label for="ethicCountry" class="required">Country <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="country" formControlName="country" class="form-control" readonly>
                             </div>
                          </div>
                          <div class="col-md-6" *ngIf="!inviteestateName">
                             <div class="form-group" tabindex="1">
                                <label for="state" class="required">State/UT <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="stateName" formControlName="stateName" class="form-control" readonly>
                             </div>
                          </div>
                          <div class="col-md-6" *ngIf="inviteestateName">
                             <div class="form-group" tabindex="1">
                                <label for="state" class="required">State/UT <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" placeholder="State Name" formControlName="stateName" maxlength="70" readonly [ngClass]="{ 'is-invalid': f.stateName.invalid && (f.stateName.dirty || f.stateName.touched) }">
                                <div *ngIf="formGroupId.controls['stateName'].hasError('required')" class="failed-validation" class="errorColor"> State/UT is Required </div>
                                <div *ngIf="submitted &&  formGroupId.controls['stateName'].invalid 
                                   && (formGroupId.controls['stateName'].dirty)" class="invalid-feedback">
                                   <div *ngIf="formGroupId.controls['stateName'].errors.required">
                                      <b> State/UT is required.</b>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="col-md-6" *ngIf="!inviteecityName">
                             <div class="form-group" tabindex="1">
                                <label for="state" class="required">City <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" id="cityName" formControlName="cityName" class="form-control" readonly>
                             </div>
                          </div>
                          <div class="col-md-6" *ngIf="inviteecityName">
                             <div class="form-group" tabindex="1">
                                <label for="state" class="required">City <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control" placeholder="City Name" formControlName="cityName" maxlength="70" readonly [ngClass]="{ 'is-invalid': f.cityName.invalid && (f.cityName.dirty || f.cityName.touched) }">
                                <div *ngIf="formGroupId.controls['cityName'].hasError('required')" class="failed-validation" class="errorColor"> City is Required </div>
                                <div *ngIf="submitted &&  formGroupId.controls['cityName'].invalid 
                                   && (formGroupId.controls['cityName'].dirty)" class="invalid-feedback">
                                   <div *ngIf="formGroupId.controls['cityName'].errors.required">
                                      <b> City is required.</b>
                                   </div>
                                </div>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <label for="grivZipCode" class="required">PIN Code <span class="text-danger">*</span>
                             </label>
                             <input id="pinCode" name="pinCode" placeholder="PIN Code" formControlName="pinCode" class="form-control" type="text" value="" readonly>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6"></div>
                          <div class="col-md-6"></div>
                       </div>
                    </div>
                    <div class="col-md-12">
                       <h5 class="headingValue">Purpose of Inviting Foreign Dentist</h5>
                       <span class="text-danger">*</span>
                       <hr>
                       <textarea class="form-control" rows="5" placeholder="Purpose of Conducting/ Inviting Foreign Dentist *" formControlName="purposeConducting" [ngClass]="{ 'is-invalid': formGroupId.controls.purposeConducting.invalid && (formGroupId.controls.purposeConducting.dirty) }"></textarea>
                       <div *ngIf="submitted && formGroupId.controls['purposeConducting'].hasError('required')" class="failed-validation" class="errorColor"> Purpose of Inviting is Required </div>
                       <br>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="startDate" class="required"> Start Date <span class="text-danger">*</span>
                                </label>
                                <input type="date" class="form-control" formControlName="startDate" [min]="today1" (change)="selecetdDate($event.target.value, false)" [ngClass]="{ 'is-invalid': formGroupId.controls.startDate.invalid && (formGroupId.controls.startDate.dirty) }" onkeydown="return false" />
                                <div *ngIf="submitted && formGroupId.controls['startDate'].hasError('required')" class="failed-validation" class="errorColor"> Start Date is Required </div>
                             </div>
                          </div>
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="endDate" class="required"> End Date <span class="text-danger">*</span>
                                </label>
                                <input type="date" class="form-control" formControlName="endDate" [min]="maxDate" (change)="selectedValidDate($event.target.value, false)" [ngClass]="{ 'is-invalid': formGroupId.controls.endDate.invalid && (formGroupId.controls.endDate.dirty) }" onkeydown="return false" />
                                <div *ngIf="submitted && formGroupId.controls['endDate'].hasError('required')" class="failed-validation" class="errorColor"> End Date is Required </div>
                             </div>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6">
                             <div class="form-group">
                                <label for="phoneNo" class="required">Venue of the Program <span class="text-danger">*</span>
                                </label>
                                <textarea class="form-control" rows="5" placeholder="Venue of the Program *" formControlName="venueProgram" [ngClass]="{ 'is-invalid': formGroupId.controls.venueProgram.invalid && (formGroupId.controls.venueProgram.dirty) }"></textarea>
                                <div *ngIf="submitted && formGroupId.controls['venueProgram'].hasError('required')" class="failed-validation" class="errorColor"> Venue is Required </div>
                             </div>
                          </div>
                       </div>
                       <div class="row">
                          <div class="col-md-6"></div>
                          <div class="col-md-6"></div>
                       </div>
                    </div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row"></div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row"></div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row">
                       <div class="col-md-6"></div>
                       <div class="col-md-6"></div>
                    </div>
                    <div class="row">
                       <div class="col-md-6"></div>
                    </div>
                    <div class="col-md-12">
                       <h5 class="headingValue">Invitee Information</h5>
                       <hr>
        <form [formGroup]="form" novalidate>
        <div formArrayName="itemRows">
        <div *ngIf="form.get('itemRows')['controls'] !=null && form.get('itemRows')['controls'] !=undefined">
        <div class="row" *ngFor="let item of form.get('itemRows')['controls'];let i=index">
        <div class="col-md-12">
        <h5 class="headingValue">Invitee {{i+1}}</h5>
        <hr>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="inviteecertificateRegistration" class="required">Registration Number <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" id="inviteecertificateRegistration" formControlName="inviteecertificateRegistration" placeholder="Registration Number" maxlength="15" [ngClass]="{ 'is-invalid': item.controls.inviteecertificateRegistration.invalid && (item.controls.inviteecertificateRegistration.dirty || item.controls.inviteecertificateRegistration.touched) }" data-validation-error-msg='Registration number is required'>
        <div *ngIf="submitted && item.controls['inviteecertificateRegistration'].hasError('required')" class="failed-validation" class="errorColor"> Registration Number is Required </div>
        <div *ngIf="item.controls['inviteecertificateRegistration'].hasError('maxlength')" class="failed-validation" class="errorColor">
        <b> Registration Number cannot be more than 10 characters long. </b>
        </div>
        <div *ngIf="item.controls['inviteecertificateRegistration'].hasError('minlength')" class="failed-validation" class="errorColor">
        <b> Registration Number cannot be less than 6 characters long. </b>
        </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="phoneNo" class="required">Upload Registration Certificate <span class="text-danger">*</span>
        </label>
        <span> (Max size.200 KB, file format .pdf only) </span>
        <br>
        <input type="file" accept="pdf" #inviteedocumentaryProof class="form-group" (change)="onSelectInviteeFile($event,'inviteedocumentaryProof',i)">
        <br>
        <div class="iconCard" *ngIf="item?.value?.inviteedocumentaryProof?.includes('/')">
            <span><i class="far fa-file-alt docIcons"></i> {{item?.value?.inviteedocumentaryProof?.split('/').pop()}}</span>
            <a class="downloadView" (click)="viewDocuments(item?.value?.inviteedocumentaryProof, item?.value?.inviteedocumentaryProof?.split('/').pop())">
               <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
            </a> 
         </div>
        <div *ngIf="submitted && item.controls['inviteedocumentaryProof'].hasError('required')" class="failed-validation" class="errorColor"> Registration Certificate is Required </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="inviteename" class="required">Invitee Name <span class="text-danger">*</span>
        </label>
        <input id="inviteename" name="inviteename" tabindex="1" formControlName="inviteename" placeholder="Invitee Name" type="text" class="form-control" [ngClass]="{ 'is-invalid': item.controls.inviteename.invalid && (item.controls.inviteename.dirty || item.controls.inviteename.touched) }">
        <div *ngIf="submitted && item.controls['inviteename'].hasError('required')" class="failed-validation" class="errorColor"> Invitee Name is Required </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="inviteeemail" class="required">Email Address <span class="text-danger">*</span>
        </label>
        <input id="inviteeemail" name="inviteeemail" tabindex="2" formControlName="inviteeemail"  maxlength="100"  placeholder="Email Address" type="text" class="form-control" value="" [ngClass]="{ 'is-invalid': item.controls.inviteeemail.invalid && (item.controls.inviteeemail.dirty || item.controls.inviteeemail.touched) }">
        <div *ngIf="submitted && item.controls['inviteeemail'].hasError('required')" class="failed-validation" class="errorColor"> Email Address Required </div>
        <div *ngIf="item.controls['inviteeemail'].hasError('pattern')" class="failed-validation" class="errorColor"> Invalid Email Address </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="phoneNo" class="required">Mobile Number <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" id="inviteemobileNumber" formControlName="inviteemobileNumber" placeholder="Mobile Number" (keypress)="keyPresspincode($event)" maxlength="15" [ngClass]="{ 'is-invalid': item.controls.inviteemobileNumber.invalid && (item.controls.inviteemobileNumber.dirty || item.controls.inviteemobileNumber.touched) }" (keypress)="keyPress($event)" data-validation-error-msg='Mobile Number is required'>
        <div *ngIf="submitted && item.controls['inviteemobileNumber'].hasError('required')" class="failed-validation" class="errorColor"> Mobile Number is Required </div>
        <div *ngIf="item.controls['inviteemobileNumber'].hasError('pattern')" class="failed-validation" class="errorColor"> Mobile Number should have starts with 9,8,7,6 </div>
        <div *ngIf="item.controls['inviteemobileNumber'].hasError('minlength')" class="failed-validation" class="errorColor"> Mobile Number should have 10 digits </div>
      </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="councilName" class="required">Council Name <span class="text-danger">*</span>
        </label>
        <input id="councilName" name="councilName" tabindex="2" formControlName="councilName" placeholder="Enter Council Name" type="text" class="form-control" value="" [ngClass]="{ 'is-invalid': item.controls.councilName.invalid && (item.controls.councilName.dirty || item.controls.councilName.touched) }">
        <div *ngIf="submitted && item.controls['councilName'].hasError('required')" class="failed-validation" class="errorColor"> Council Name is Required </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="validUpto" class="required">Valid Upto <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="validUpto" [min]="validDate" [ngClass]="{ 'is-invalid': item.controls.validUpto.invalid && (item.controls.validUpto.dirty || item.controls.validUpto.touched) }" onkeydown="return false" />
        <div *ngIf="submitted && item.controls['validUpto'].hasError('required')" class="failed-validation" class="errorColor"> Valid Upto is Required </div>
        </div>
        </div>
        <div class="col-md-12">
        <h5 class="headingValue">Invitee Address</h5>
        <hr>
        <div class="row">
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label class="required">Address Line 1 <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" placeholder="Address Line 1" formControlName="inviteeaddressLine1" [ngClass]="{ 'is-invalid': item.controls.inviteeaddressLine1.invalid && (item.controls.inviteeaddressLine1.dirty || item.controls.inviteeaddressLine1.touched) }">
        <div *ngIf="submitted && item.controls['inviteeaddressLine1'].hasError('required')" class="failed-validation" class="errorColor"> Address Line 1 is Required </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label class="required">Address Line 2 <span class="text-danger"></span>
        </label>
        <input type="text" class="form-control" placeholder="Address Line 2" formControlName="inviteeaddressLine2" [ngClass]="{ 'is-invalid': item.controls.inviteeaddressLine2.invalid && (item.controls.inviteeaddressLine2.dirty || item.controls.inviteeaddressLine2.touched) }">
        <div *ngIf="submitted && item.controls['inviteeaddressLine2'].hasError('required')" class="failed-validation" class="errorColor"> Address Line 2 is Required </div>
        </div>
        </div>
        <div class="col-md-6">
        <div class="form-group" tabindex="1" [formGroupName]="i">
        <label for="inviteeCountry" class="required">Country <span class="text-danger">*</span>
        </label>
        <select class="form-control" formControlName="inviteecountryId" (change)="findInviteeState(i)">
        <option value="" disabled selected>Select Country</option>
        <option *ngFor=" let  details of countryList" [value]="details.countryId">
        {{details.countryName}}
        </option>
        </select>
        <div *ngIf="submitted && item.controls['inviteecountryId'].hasError('required')" class="failed-validation" class="errorColor"> Country is Required </div>
        </div>
        </div>
        <div class="col-md-6" *ngIf="item.inviteeshowstateName">
        <div class="form-group" tabindex="1" [formGroupName]="i">
        <label for="inviteestate" class="required">State <span class="text-danger">*</span>
        </label>
        <select class="form-control" formControlName="inviteestateId" (change)="findInviteeCityNew(i)">
        <option value="" disabled selected>Select State</option>
        <option *ngFor="let details of inviteestateList" [value]="details.stateId">
        {{details.stateName}}
        </option>
        </select>
        <div *ngIf="submitted && item.controls['inviteestateId'].hasError('required')" class="failed-validation" class="errorColor"> State is Required </div>
        </div>
        </div>
        <div class="col-md-6" *ngIf="!item.inviteeshowstateName">
        <div class="form-group" tabindex="1" [formGroupName]="i">
        <label for="inviteestateName" class="required">State <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" placeholder="State Name" formControlName="inviteestateName" [ngClass]="{ 'is-invalid': item.controls.inviteestateName.invalid && (item.controls.inviteestateName.dirty || item.controls.inviteestateName.touched) }">
        <div *ngIf="submitted && item.controls['inviteestateName'].hasError('required')" class="failed-validation" class="errorColor"> State is Required </div>
        </div>
        </div>
        <div class="col-md-6" *ngIf="item.inviteeshowcityName">
        <div class="form-group" tabindex="1" [formGroupName]="i">
        <label for="city" class="required">City <span class="text-danger">*</span>
        </label>
        <select class="form-control" formControlName="inviteecityId">
        <option value="" disabled selected>Select City</option>
        <option *ngFor="let details of inviteecityList" [value]="details.cityId">
        {{details.cityName}}
        </option>
        </select>
        <div *ngIf="submitted && item.controls['inviteecityId'].hasError('required')" class="failed-validation" class="errorColor"> City is Required </div>
        </div>
        </div>
        <div class="col-md-6" *ngIf="!item.inviteeshowcityName">
        <div class="form-group" tabindex="1" [formGroupName]="i">
        <label for="city" class="required">City <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" placeholder="City Name" formControlName="inviteecityName" [ngClass]="{ 'is-invalid': item.controls.inviteecityName.invalid && (item.controls.inviteecityName.dirty || item.controls.inviteecityName.touched) }">
        <div *ngIf="submitted && item.controls['inviteecityName'].hasError('required')" class="failed-validation" class="errorColor"> City is Required </div>
        </div>
        </div>
        <div class="col-md-6" [formGroupName]="i">
        <label for="inviteepincode" class="required">PIN Code <span class="text-danger">*</span>
        </label>
        <input id="inviteepinCode" name="inviteepinCode" placeholder="PIN Code" formControlName="inviteepinCode" maxlength="6" class="form-control" type="text" value="" [ngClass]="{ 'is-invalid': item.controls.inviteepinCode.invalid && (item.controls.inviteepinCode.dirty || item.controls.inviteepinCode.touched) }">
        <div *ngIf="submitted && item.controls['inviteepinCode'].hasError('required')" class="failed-validation" class="errorColor"> Pin Code is Required </div>
        </div>
        </div>
        <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6"></div>
        </div>
        </div>
        <div class="col-md-12">
        <h5 class="headingValue">Upload Complete Biodata</h5>
        <hr>
        <div class="row">
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <label for="bioData" class="required"> Complete Biodata <span class="text-danger">*</span>
        </label>
        <span> (Max size.200 KB, file format .pdf only) </span>
        <br>
        <input type="file" accept="pdf" #bioData class="form-group" (change)="onSelectInviteeFile($event,'bioData',i)" [ngClass]="{ 'is-invalid': item.controls.bioData.invalid && (item.controls.bioData.dirty || item.controls.bioData.touched) }">
        <br>
        <div class="iconCard" *ngIf="item?.value?.bioData?.includes('/')">
            <span><i class="far fa-file-alt docIcons"></i> {{item?.value?.bioData?.split('/').pop()}}</span>
            <a class="downloadView" (click)="viewDocuments(item?.value?.bioData, item?.value?.bioData?.split('/').pop())">
               <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
            </a> 
         </div>
        <div *ngIf="submitted && item.controls['bioData'].hasError('required')" class="failed-validation" class="errorColor"> Complete Biodata is Required </div>
        </div>
        </div>
        </div>
        </div>
        <div class="col-md-12">
        <h5 class="headingValue">Self Declaration Documents</h5>
        <hr>
        <div class="row">
        <div class="col-md-6">
        <div class="form-group" [formGroupName]="i">
        <a class="downloadView">
        <span>
        <i class="far fa-file-alt docIcons"></i>Please click here to download the sample format <i class="fas fa-cloud-download-alt" (click)="viewDocuments(sampleDocURL, sampleDocURL?.split('/').pop())" style=" cursor: pointer;color: #3D78BE;"></i>
        </span>
        </a>
        <br>
        <br>
        <label for="briefBio" class="required"> Upload Self Declaration <span class="text-danger">*</span>
        </label>
        <span> (Max size.200 KB, file format .pdf only) </span>
        <br>
        <input type="file" accept="pdf" #briefBio class="form-group" (change)="onSelectInviteeFile($event,'briefBio',i)" [ngClass]="{ 'is-invalid': item.controls.briefBio.invalid && (item.controls.briefBio.dirty || item.controls.briefBio.touched) }">
        <br>
        <div class="iconCard" *ngIf="item?.value?.briefBio?.includes('/')">
            <span><i class="far fa-file-alt docIcons"></i> {{item?.value?.briefBio?.split('/').pop()}}</span>
            <a class="downloadView" (click)="viewDocuments(item?.value?.briefBio, item?.value?.briefBio?.split('/').pop())">
               <i class="fas fa-eye" style=" cursor: pointer;color: #3D78BE;"></i>
            </a> 
         </div>
        <div *ngIf="submitted && item.controls['briefBio'].hasError('required')" class="failed-validation" class="errorColor"> Self Declaration is Required </div>
        </div>
        </div>
        </div>
        </div>
        <hr>
        <div class="col-md-6 text-right" style="margin-top: 2em;">
        <button class="btn btn-success btn-sm" *ngIf="i>=0 && this?.userDetails?.statusId!=9" (click)="addRow('ToAddress',i)">
        <i class="fas fa-plus-circle"></i> Add Foreign Dentist </button> &nbsp;&nbsp; <button class="btn btn-secondary btn-sm" *ngIf="i>0" (click)="removeRows(i)">
        <i class="fas fa-minus-circle"></i> Remove </button>
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>
        <div class="row">
        <div class="col-md-12" style="text-align: right;">
        <button class="btn btn-primary mx-2 draft-btn" type="submit" (click)="onDraftSubmit('SAVEASDRAFT')">Save As Draft</button>
        <button class="btn btn-primary mx-2" type="submit" (click)="onSubmit('SUBMIT')">Submit</button>
        <button class="btn btn-secondary mx-2" (click)="back()">Back</button>
        </div>
        </div>
        </div>
        </div>
        <div class="clearfix"></div>
        </div>
        </form>
     </div>
  </div>
</div>